import { render, staticRenderFns } from "./ManagementList.vue?vue&type=template&id=5ae278d5&scoped=true&"
import script from "./ManagementList.vue?vue&type=script&lang=js&"
export * from "./ManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae278d5",
  null
  
)

export default component.exports